import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "au-page-header" }
const _hoisted_2 = { class: "au-page-title" }
const _hoisted_3 = {
  key: 0,
  class: "au-page-subtitle"
}
const _hoisted_4 = {
  key: 0,
  class: "d-flex gap-2 flex-wrap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.title), 1),
      (_ctx.subtitle)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.subtitle), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.$slots.actions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "actions")
        ]))
      : _createCommentVNode("", true)
  ]))
}